import { CSR_ASSIGNMENT_SETTINGS } from "../../types";

export default (state = {}, action) => {

  if (action.type === CSR_ASSIGNMENT_SETTINGS) {
    state = { ...state, ...action.payload }
  };
  return state;

};
